import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import OpenInNew from '@material-ui/icons/OpenInNew';
import * as React from 'react';

export class SponsorListing extends React.Component<{ listing: { link?: string, primary: string, secondary?: string } }, {}> {

  public render() {
    const { listing: { link, primary, secondary } } = this.props;

    const listing = (
      <ListItem>
        <ListItemText primary={primary} secondary={secondary} />
        { link ? <OpenInNew /> : '' }
      </ListItem>
    );

    if (!link) {
      return listing;
    }

    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        {listing}
      </a>
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/Sponsor/sponsor-listing.tsx